import * as React from "react";
import { TextInput, NumberInput, Create, required } from "react-admin";
import { FaqCreateComponent } from "./";
import { TinyMCEContentInput } from "src/components/input";
import { Grid } from "@mui/material";
import { SimpleForm } from "src/enterprise/ra-rbac";

export const FaqCreate = () => {
  return (
    <Create component={FaqCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={8} sm={12}>
            <TextInput source="question" validate={required()} />
          </Grid>
          <Grid item lg={8} sm={12}>
            <NumberInput source="sort_order" />
          </Grid>
          <Grid item sm={12}>
            <TinyMCEContentInput source="answer" required base64></TinyMCEContentInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
